import { View } from 'foundations-components/components/View';
import CompanionTabWrapper from './CompanionTabWrapper';
import QuizMeTab from './QuizMeTab';
import { jsx as _jsx } from "react/jsx-runtime";
const QuizMeTabContainer = ({
  additionalTracking,
  asyncGenerateError,
  asyncGenerateLoading,
  contentType,
  lesson,
  lessonContentId,
  onAsyncRegenerateQuiz,
  onRegenerateSingleVideoQuiz,
  primaryContentId
}) => {
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: "400",
    children: /*#__PURE__*/_jsx(CompanionTabWrapper, {
      children: /*#__PURE__*/_jsx(QuizMeTab, {
        additionalTracking: additionalTracking,
        asyncGenerateError: asyncGenerateError,
        asyncGenerateLoading: asyncGenerateLoading,
        contentType: contentType,
        lesson: lesson,
        lessonContentId: lessonContentId,
        onAsyncRegenerateQuiz: onAsyncRegenerateQuiz,
        onRegenerateSingleVideoQuiz: onRegenerateSingleVideoQuiz,
        primaryContentId: primaryContentId
      })
    })
  });
};
export default QuizMeTabContainer;